import { Moment } from 'moment'

import { BaseModel } from './base.model'
import { Document } from './document.model'
import { ExamResult } from './exam-result.model'
import { DriverLicense } from './driver-license.model'
import { Driver } from './driver.model'
import { Infraction } from './infraction.model'
import { AccessorInfraction } from './accessor-infraction.model'
import { Photo } from './photo.model'
import { Center } from './center.model'
import { Program } from './program.model'
import { User } from './user.model'
import { SessionInfraction } from './session-infraction.model'
import { ModeratedInfraction } from './moderated-infraction.model'
import { RecognizedSpeech } from './recognized-speech.model'
import { SessionInteractive } from './session-interactive.model'
import { SessionWarning } from './session-warning.model'
import { SessionDecorator } from 'decorators'
import { DocumentDecorator } from 'decorators'
import { DriverLicenseDecorator } from 'decorators'
import { CenterProgram } from './center-program.model'
import { Interview, InterviewResult } from './interview.model'

export interface SessionExamResult {
  name: string
  grade: number
}

export class Session extends BaseModel<Session> {
  static DEFAULT_ATTRIBUTES = {}

  accessorComment: string
  videoaccessorComment: string
  interviewerComment: string
  moderatorComment: string
  accessorId: number
  moderatorId: number
  accessorPhotos: Photo[]
  videoaccessorPhotos: Photo[]
  additionalLicensePhotos: Photo[]
  additionalPassportPhotos: Photo[]
  additionalPortraitPhotos: Photo[]
  approvalState: string
  moderatorApprovalState: string
  birthdate: Moment
  centerId: number
  centerName: string
  completedAt: Moment
  controlPhotos: Photo[]
  createdAt: Moment
  deviceNumber: string
  deviceUid: string
  deviceAppPackageId: number
  exam: ExamResult
  driver: Driver
  firstname: string
  id: number
  sessionInfractions: SessionInfraction[]
  moderatedInfractions: ModeratedInfraction[]
  lastname: string
  licenseIssuedAt: Moment
  licenseNumber: string
  licensePhoto: Photo
  document: Document
  driverLicense: DriverLicense
  middlename: string
  passportPhoto: Photo
  phone: string
  portraitPhoto: Photo
  state: string
  grade: number
  speechUuid: string
  recognizedSpeeches: RecognizedSpeech[]
  sessionInteractives: SessionInteractive[]
  center: Center
  program: Program
  videoaccessor: User
  videoaccessorApprovalState: string
  videoaccessorAutoapproved: boolean
  warning: string
  hasExam: boolean
  isNew: boolean = false
  appVersion: string
  sessionWarnings: SessionWarning[]
  examStartedAt: Moment
  interviewer: User
  interviewState: string
  needInterview: boolean
  sessionInterviewInfractions: SessionInfraction[]
  examResults: SessionExamResult[]
  centerProgram: CenterProgram
  isExported: boolean
  yandexExamId: string
  exportErrorMessage: string
  exportDate: Moment
  interview: Interview
  interviewResult: InterviewResult

  private decorator: SessionDecorator
  private documentDecorator: DocumentDecorator
  private driverLicenseDecorator: DriverLicenseDecorator

  get hasWarnings(): boolean {
    return this.sessionWarnings && this.sessionWarnings.length > 0
  }

  isCompleted(): boolean {
    return this.state == 'completed'
  }

  isNotChecked(): boolean {
    return this.approvalState == 'not_checked'
  }

  isModeratorAssigned(): boolean {
    return this.moderatorApprovalState == 'moderator_assigned'
  }

  isAccessorStarted(): boolean {
    return this.approvalState == 'accessor_started'
  }

  isModeratorStarted(): boolean {
    return this.moderatorApprovalState == 'moderator_started'
  }

  isApproved(): boolean {
    return this.approvalState == 'approved'
  }

  isRejected(): boolean {
    return this.approvalState == 'rejected'
  }

  // isExported(): boolean {
  //   return !(this.yandexExamId == undefined)
  // }

  isExamStarted(): boolean {
    return this.state == 'exam_started'
  }

  get isStarted(): boolean {
    return this.state == 'started'
  }

  detectedInfractions(): Infraction[] {
    return this.sessionInfractions
      .filter(sInfraction =>  sInfraction.detected && !!sInfraction.infraction)
      .map(sInfraction =>  sInfraction.infraction)
  }

  detectedModeratedInfractions(): AccessorInfraction[] {
    return this.moderatedInfractions
      .filter(sInfraction => sInfraction.detected && !!sInfraction.accessorInfraction )
      .map(sInfraction => sInfraction.accessorInfraction)
  }

  get detectedInterviewInfractions(): Infraction[] {
    return this.sessionInterviewInfractions ? this.sessionInterviewInfractions
      .filter(sInf => sInf.detected && !!sInf.infraction)
      .map(sInf => sInf.infraction) : []
  }

  decorate(): SessionDecorator {
    if (!this.decorator) { this.decorator = new SessionDecorator(this) }
    return this.decorator
  }

  decorateDocument(): DocumentDecorator {
    if (!this.documentDecorator) { this.documentDecorator = new DocumentDecorator(this.document) }
    return this.documentDecorator
  }

  decorateDriverLicense(): DriverLicenseDecorator {
    if (!this.driverLicenseDecorator) { this.driverLicenseDecorator = new DriverLicenseDecorator(this.driverLicense) }
    return this.driverLicenseDecorator
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/session.model.ts